import { ContractConceptCategory } from '../../../../models/Entities/Contracts/ContractConceptCategory';

/** Reglas del drawer de categorías, sin React ni store. */

export const NAME_MAX = 200;
export const DESCRIPTION_MAX = 500;

export interface CategoryDraft {
    name: string;
    description: string;
}

export interface DraftErrors {
    name?: string;
    description?: string;
}

/** Mensajes en español: el drawer los muestra tal cual bajo cada campo. */
export const validateDraft = (draft: CategoryDraft, others: ContractConceptCategory[], editingId?: number): DraftErrors => {
    const errors: DraftErrors = {};
    const name = draft.name.trim();
    if (!name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > NAME_MAX) errors.name = `Como máximo ${NAME_MAX} caracteres.`;
    else if (others.some((item) => item.id !== editingId && (item.name || '').trim().toLowerCase() === name.toLowerCase())) {
        errors.name = 'Ya existe una categoría con ese nombre.';
    }
    if (draft.description.trim().length > DESCRIPTION_MAX) errors.description = `Como máximo ${DESCRIPTION_MAX} caracteres.`;
    return errors;
};

export const hasErrors = (errors: DraftErrors): boolean => Object.keys(errors).length > 0;

/** Lo que se manda al servidor: nombre sin espacios sobrantes, descripción vacía como null. */
export const toPayload = (draft: CategoryDraft): { name: string; description: string | null } => ({
    name: draft.name.trim(),
    description: draft.description.trim() || null
});

export const draftOf = (category?: ContractConceptCategory | null): CategoryDraft => ({
    name: category?.name ?? '',
    description: category?.description ?? ''
});

/** Filtro por nombre o descripción, sin acentos ni mayúsculas. */
const fold = (text: string | null | undefined): string =>
    (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const filterCategories = (list: ContractConceptCategory[], search: string): ContractConceptCategory[] => {
    const needle = fold(search).trim();
    if (!needle) return list;
    return list.filter((item) => fold(item.name).includes(needle) || fold(item.description).includes(needle));
};

/**
 * El servidor rechaza la baja mientras algún concepto use la categoría. Se
 * reconoce por el código o el texto para explicarlo con palabras propias.
 */
export const isInUseError = (error: { ErrorCode?: number; ErrorMessage?: string; Errors?: string[] } | undefined): boolean => {
    if (!error) return false;
    if (error.ErrorCode === 409) return true;
    const text = [error.ErrorMessage, ...(error.Errors ?? [])].join(' ').toLowerCase();
    return /in use|en uso|used by|utiliza|concepts? (that )?use|conceptos/.test(text);
};
